export default __webpack_public_path__ + "static/media/NIAS0230.34I-43019_-25727_0.03669327.jpg";